import { hasPermission, PERMISSIONS } from "./permissions.js";

export function isActiveViewerLink(link, actorEmail) {
  if (Number(link?.status) !== 1) return false;
  if (!link?.viewer_email || !actorEmail) return false;

  return link.viewer_email.toLowerCase() === actorEmail.toLowerCase();
}

export function hasActiveViewerLink(links, actorEmail) {
  return (links || []).some((link) => isActiveViewerLink(link, actorEmail));
}

export function canViewAssessmentResults({
  permissions,
  actorEmail,
  links = [],
}) {
  if (hasPermission(permissions, PERMISSIONS.ASSESSMENTS_EVALUATE)) {
    return true;
  }

  return (
    hasPermission(permissions, PERMISSIONS.ASSESSMENTS_VIEW) &&
    hasActiveViewerLink(links, actorEmail)
  );
}
